var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh","width":"100vw"}},[_c('div',{staticStyle:{"height":"100vh","width":"100%"},attrs:{"id":"fusion5"}})])
}]

export { render, staticRenderFns }